module.exports = __webpack_public_path__ + "img/upload_icon.467c9078.svg";